import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { Sacado } from '../models/sacado.model';
import { CollectionService } from '../collection.service';
import { FormGroup } from '@angular/forms';
import { Auth } from '../../../autentication/Auth';
import { AutenticationService } from '../../../autentication/autentication.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { EmitBillet } from '../models/emit-billet';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Util } from '../../../utils/util';
import { Billet } from '../models/billet';

@Component({
	selector: 'app-collection-resume-final',
	templateUrl: './resume-final.component.html',
	styleUrls: ['./resume-final.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionResumeFinalComponent implements OnInit {

	public sacadoList: Array<ListItem> = [];
	public paymentList: Array<ListItem> = [];
	public sacado: Sacado = new Sacado();
	public value = 0;
	public date = '';
	public form: FormGroup;
	public submited = false;

	constructor(
		private collectionService: CollectionService,
		private autenticationService: AutenticationService,
		private router: Router) {}

	ngOnInit(): void {
		this.sacado = this.collectionService.getSacadoToEmit();
		this.value = this.collectionService.getValueToEmit();
		this.date = this.collectionService.getDateToEmit();
		this.buildSacadoList();
	}

	buildSacadoList() {
		this.sacadoList = [];
		this.sacadoList.push(new ListItem(this.sacado.cPFCNPJ.length > 11 ? 'Razão Social' : 'Nome', this.sacado.nome));
		this.sacadoList.push(new ListItem('CPF/CNPJ', this.sacado.cPFCNPJ));
		this.sacadoList.push(new ListItem('E-mail', this.sacado.email));
		this.sacadoList.push(new ListItem('Cep', this.sacado.cEP));
		this.sacadoList.push(new ListItem('Endereço', this.sacado.endereco));
		this.sacadoList.push(new ListItem('Bairro', this.sacado.bairro));
		this.sacadoList.push(new ListItem('Número', this.sacado.numero));
		this.sacadoList.push(new ListItem('Complemento', this.sacado.complemento));
		this.sacadoList.push(new ListItem('Cidade/Estado', this.sacado.cidade + '/' + this.sacado.uF));
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	generate() {
		if (this.form.valid) {
			this.sendAssignature();
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.emitBillet();
			}
		}, error => {
			this.handleError(error);
		});
	}

	emitBillet() {
		const emitBillet: EmitBillet = {
			cPFCNPJ: this.sacado.cPFCNPJ,
			valorBoleto: this.value,
			vencimento: new Date(this.date)
		};

		this.collectionService.emitBillet(emitBillet).subscribe(data => {
			if (data.Sucesso) {
				this.collectionService.setBilletEmited(Util.keysToCamel(data.Retorno) as Billet);
				this.router.navigate(['cobranca/boleto']);
			}
		}, error => {
			this.handleError(error);
		});
	}

	handleError(error) {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	}

	editSacado() {
		this.router.navigate(['cobranca/editar/' + this.sacado.cPFCNPJ]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/collection/resume-final/resume-final.component.ts